import { Component, Input, OnInit } from '@angular/core';
import { Incapacidad } from '../../../interfaces/incapacidad';
import { HttpErrorResponse } from '@angular/common/http';
import { ImagesService } from 'src/app/services/utils/images.service';
import { ServicioEntidadService } from '../../../services/servicio-entidad.service';
import { EntidadEmpresarialEntity } from 'src/app/services/servicio-entidad.service';

@Component({
  selector: 'app-encabezado-incapacidad',
  templateUrl: './encabezado-incapacidad.component.html',
  styleUrls: ['./encabezado-incapacidad.component.css']
})
export class EncabezadoIncapacidadComponent implements OnInit {

  @Input() public incapacidad: Incapacidad;
  @Input() public code: string;
  @Input() public uncoSede: number;

  public date: Date;
  public logo: string;
  public entidadEmpresarial: EntidadEmpresarialEntity;

  constructor(
    private servicioImagenes: ImagesService,
    private servicioEntidad: ServicioEntidadService,
  ) {
    this.date = new Date();
  }

  ngOnInit() {
    this.getLogo();
    this.getEntidadEmpresarial();
  }

  private async getLogo() {
    try {
      this.logo = '';
      const response = await this.servicioImagenes.getLogo(this.code);
      response.subscribe((data: any) => {
        this.logo = data.source;
      }, (err: HttpErrorResponse) => {
        console.error('Error ReporteOrdenMedicaComponent.getLogo()', err);
      });
    } catch (e) {
      console.error('Catch ReporteOrdenMedicaComponent.getLogo()', e);
    }
  }

  private async getEntidadEmpresarial() {
    try {
      const response = await this.servicioEntidad.getEntidadEmpresarial(this.code, this.uncoSede);
      response.subscribe((data: EntidadEmpresarialEntity[]) => {
        if (data && data.length > 0) {
          this.entidadEmpresarial = data[0];
        }
      }, (err: HttpErrorResponse) => {
        console.error('Error ReporteOrdenMedicaComponent.getEntidadEmpresarial()', err);
      });
    } catch (e) {
      console.error('Catch ReporteOrdenMedicaComponent.getEntidadEmpresarial()', e);
    }
  }

}
